import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * Configured to allow safe HTML tags while removing potentially dangerous content
 */
export const sanitizeHtml = (html: string): string => {
  if (!html) return '';
  
  // Configure DOMPurify with safe options
  const config = {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'blockquote', 'a', 'img', 'div', 'span', 'table',
      'thead', 'tbody', 'tr', 'td', 'th', 'pre', 'code'
    ],
    ALLOWED_ATTR: [
      'href', 'src', 'alt', 'title', 'class', 'style', 'target', 'rel',
      'width', 'height', 'align'
    ],
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    FORBID_TAGS: ['script', 'object', 'embed', 'form', 'input', 'textarea', 'select', 'button'],
    FORBID_ATTR: ['onload', 'onerror', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'onchange', 'onsubmit'],
    REMOVE_EMPTY_ELEMENTS: false,
    KEEP_CONTENT: true
  };
  
  return DOMPurify.sanitize(html, config);
};

/**
 * Strict sanitization for user-generated content where only basic formatting is allowed
 */
export const sanitizeUserContent = (html: string): string => {
  if (!html) return '';
  
  const config = {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'ul', 'ol', 'li', 'blockquote'],
    ALLOWED_ATTR: [],
    FORBID_TAGS: ['script', 'object', 'embed', 'form', 'input', 'textarea', 'select', 'button', 'iframe', 'img'],
    FORBID_ATTR: ['style', 'class', 'onload', 'onerror', 'onclick'],
    REMOVE_EMPTY_ELEMENTS: true,
    KEEP_CONTENT: true
  };
  
  return DOMPurify.sanitize(html, config);
};